export default "__VITE_ASSET__wtzc4DtZ__"